// extracted by css-extract-rspack-plugin
export default {"spinner":"spinner-l2YO4W","spin":"spin-PSsLv2"};